/**
 * Formats any raw date string or Date object into DD/MM/YYYY format.
 * Handles YYYY-MM-DD, DD-MM-YYYY, DD/MM/YYYY, ISO timestamps, etc.
 *
 * @param {string | Date | null | undefined} raw
 * @returns {string} Formatted date string in DD/MM/YYYY, or empty string if invalid.
 */
export function formatDobToDmy(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (!s) return "";

  // 1) Match YYYY-MM-DD or YYYY/MM/DD (e.g. 1998-05-20 or 1998/05/20)
  const matchYmd = s.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (matchYmd) {
    const [, y, m, d] = matchYmd;
    return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
  }

  // 2) Match DD-MM-YYYY or DD/MM/YYYY (e.g. 20-05-1998 or 20/05/1998)
  const matchDmy = s.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
  if (matchDmy) {
    const [, d, m, y] = matchDmy;
    return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
  }

  // 3) Try Date constructor (e.g. ISO string "1998-05-20T00:00:00.000Z")
  const dateObj = new Date(s);
  if (!isNaN(dateObj.getTime())) {
    const d = String(dateObj.getDate()).padStart(2, "0");
    const m = String(dateObj.getMonth() + 1).padStart(2, "0");
    const y = dateObj.getFullYear();
    return `${d}/${m}/${y}`;
  }

  return s;
}
